module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow_black-550467d75284137f79c4c4a06aff8597.svg";